import { computed, readonly, ref } from 'vue'
import { defineStore } from 'pinia'

export enum ActionCableChannelState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  SUBSCRIBED = 'subscribed',
  REJECTED = 'rejected',
}

export const useActionCableStateStore = defineStore('actionCableState', () => {
  const channelStates = ref<Record<string, ActionCableChannelState>>({})
  const channelSubscribers = ref<Record<string, number>>({})

  const getChannelState = (channelName: string) =>
    computed(
      () =>
        channelStates.value[channelName] ??
        ActionCableChannelState.DISCONNECTED,
    )

  const isChannelSubscribed = (channelName: string) =>
    computed(
      () =>
        (channelStates.value[channelName] ??
          ActionCableChannelState.DISCONNECTED) ===
        ActionCableChannelState.SUBSCRIBED,
    )

  const setChannelState = (
    channelName: string,
    state: ActionCableChannelState,
  ) => {
    channelStates.value[channelName] = state
  }

  const registerSubscriber = (channelName: string) => {
    const current = channelSubscribers.value[channelName] ?? 0
    channelSubscribers.value[channelName] = current + 1
    if (!channelStates.value[channelName]) {
      channelStates.value[channelName] = ActionCableChannelState.DISCONNECTED
    }
  }

  const unregisterSubscriber = (channelName: string) => {
    const current = channelSubscribers.value[channelName] ?? 0
    if (current <= 1) {
      channelSubscribers.value[channelName] = 0
      channelStates.value[channelName] = ActionCableChannelState.DISCONNECTED
      return
    }

    channelSubscribers.value[channelName] = current - 1
  }

  return {
    channelStates: readonly(channelStates),
    channelSubscribers: readonly(channelSubscribers),
    getChannelState,
    isChannelSubscribed,
    setChannelState,
    registerSubscriber,
    unregisterSubscriber,
  }
})
